<template>
    <div>
        <div class="page-header page-header-small clear-filter">
            <parallax class="page-header-image"
                      style="background-image:url('img/bg3.jpg')">
            </parallax>
            <div class="content-center brand">
                <h1 class="h1-seo">Privacy statement</h1>
            </div>
        </div>

        <section id="general" class="section">
            <div class="container">
                <div class="row justify-content-md-center">
                    <div class="col-md-12 col-lg-8">
                        <p>The purpose of this document is to provide you with information on how Alpha Based Capital Fund Management BV (ABC) uses your personal data and what data protection rights you have.<br>
<br></p>
<h4>Responsibility for data processing</h4><br>
Alpha Based Capital Fund Management B.V.<br>
Papendorpseweg 75<br>
3528 BJ Utrecht, the Netherlands<br>
T: +31 (0) 85 064 5729<br>
<br>
<h4>Changes to the Privacy Statement<br></h4>ABC reserves the right to update or change this privacy statement at any time. The most recent version can be found at <a href="http://www.evaluationcapital.com">www.evaluationcapital.com</a>. If ABC makes any material changes to the privacy statement, we will notify you in advance.<br>
<br>
<h4>Data used by ABC<br></h4>ABC processes personal data it receives from its clients or other stakeholders in the context of its business relationship. It also processes – if this is necessary for the execution of its services – personal data obtained from public sources (trade registers, press, internet). Relevant personal data are personal details (name, address, contact details, date of birth, place of birth and nationality), identification data (including passport details and the tax identification number) and authentication details (including signature).<br>
<br>
<h4>Purposes and legal basis of the processing</h4><br>
ABC processes personal data for various purposes:
<p>Alpha Based Capital Fund Management B.V.<br>
Papendorpseweg 75<br>
3528 BJ Utrecht, the Netherlands<br>
T: +31 (0) 85 064 5729</p>
<h4>Purposes and legal basis of the processing</h4><br>
ABC processes personal data for various purposes:
<ol>
  <li>The execution of an agreement</li>
</ol>
<p>The processing of personal data is necessary for the management of an investment fund in which the client invests.</p>
<ol>
  <li>Based on your consent</li>
</ol>
<p>The processing of personal data is possible insofar as you have given permission to process personal data for certain objectives (for example sending certain reports and newsletters). The given consent can always be withdrawn.</p>
<ol>
  <li>On the basis of legal regulations</li>
</ol>
<p>ABC has to comply with various legal obligations (e.g. the Anti-Money Laundering and Terrorist Financing Act, the Financial Supervision Act and tax legislation). The purpose of processing includes acceptance of customers and compliance with duty of care towards clients, identity checks, fraud and money laundering prevention, compliance with (fiscal) control and reporting obligations.</p>
<h4><br>
Providing data to third parties<br></h4>ABC provides personal data to third parties if and to the extent this is necessary in the context of the execution of the agreement with you. ABC engages third parties that provide support in business operations and therefore these parties process personal data. ABC selects these third parties only after careful investigation and requires these parties to apply appropriate information security measures. The main parties in this respect are:
<ol>
  <li>The administrator: Circle Investment Support Services B.V.</li>
</ol>
<p>The main tasks of the administrator, under the responsibility of the fund manager, are:</p>
<ul>
  <li>to conduct the financial and investment administration of the fund;</li>
  <li>to calculate the net asset value of the fund; and</li>
  <li>to keep the register of unit holders in the fund up to date.</li>
</ul>
<ol>
  <li>The depositary: Darwin Deposit. Services B.V.</li>
</ol>
<p>The depositary is responsible for ensuring that the fund manager acts in accordance with what has been set out in the prospectus, the conditions of management and custody, complies with applicable legislation and is charged with the custody of the assets of the fund.</p>
<p>In principle, personal data are only passed on to third parties if this is required by legal provisions, there is a legitimate interest, the client has given permission or ABC is otherwise authorized to provide the information. In this context, recipients of personal data may for example be government bodies and institutions, such as tax and supervisory authorities. Should it be necessary for the provision of services to you or for the execution of the agreement to pass on personal data to parties outside the EEA, ABC will do so only if an appropriate level is guaranteed for the protection of personal data or if a specific deviation applies.<br>
<br></p>
<h4>Security of data</h4><br>
ABC and its authorized delegates have well-secured systems and take continuous measures to prevent abuse of your data. The employees of ABC and its authorized delegates have been given clear instructions on how to handle your data.<br>
<br>
<h4>Retention of your personal data</h4><br>
ABC and its duly authorized delegates do not retain your personal data for longer than is necessary for achieving the purposes for which it was collected and processed; this with due observance of the legally required retention periods. This retention period can be extended if there is an ongoing complaint, procedure or (criminal or supervisory) investigation with regard to the (former) relationship. Thereafter, personal data are periodically deleted.<br>
<br>
<h4>Data protection rights</h4><br>
You have the following rights regarding the use of your personal data:
<ol>
  <li>you may request information about the data processing, and request an overview of your personal data;</li>
  <li>you can ask ABC to correct or supplement personal data if they are incorrect or incomplete;</li>
  <li>if you no longer want ABC to register certain data in its records, you can request this data to be deleted. Your request will be complied with, unless this is in violation of laws and regulations;</li>
  <li>this document indicates how your data will be used. If at any time you wish to restrict the use of your data or wish to oppose the processing of data, you can request ABC to do so; and</li>
  <li>if you wish, you can ask ABC to forward your details to a third party.</li>
</ol>
<p>If you wish to submit a request, you can send an e-mail to the Compliance Officer (<a href="mailto:info@alphabasedcapital.com">info@alphabasedcapital.com</a>). Your request will be answered as soon as possible, but in any case within one month of receipt. There are no costs associated with handling a request, unless this is an exceptional burden for ABC. ABC will inform you in advance if costs are being charged.<br>
<br>
More information about your privacy rights can be found on the website of the Dutch Data Protection Authority, <a href="http://www.autoriteitpersoonsgegevens.nl">www.autoriteitpersoonsgegevens.nl</a>.<br>
<br></p>
<h4>Questions or complaints</h4><br>
If you have questions and/or complaints about how ABC deals with your personal data, you can submit them to the Compliance Officer, <a href="mailto:info@alphabasedcapital.com">info@alphabasedcapital.com</a>. If you are not satisfied with the handling of your complaint, you can contact the Dutch Data Protection Authority via <a href="http://www.autoriteitpersoonsgegevens.nl">www.autoriteitpersoonsgegevens.nl</a>.<br>
<br>
                    </div>
                </div>
            </div>
        </section>
    </div>
</template>
<script>
    import { Parallax } from '@/components';

    export default {
        name: 'index',
        bodyClass: 'index-page',
        data() {
            return {
            }
        },
        components: {
            Parallax
        }
    };
</script>
<style></style>
